<template>
  <div class="slo-rep-locator">
    <SloTabs default-value="tab-1" items="start">
      <SloTab name="tab-1" :title="'Online Distributors' | t">
        <SloOnlineDistributors />
      </SloTab>
      <SloTab name="tab-2" :title="'Local Distributors & Reps' | t">
        <SloRepMap />
      </SloTab>
    </SloTabs>
  </div>
</template>

<script>
import t from '../../js/main/i18n';
import SloLoader from './SloLoader.vue';
import SloButton from './SloButton.vue';
import SloTabs from './SloTabs.vue';
import SloTab from './SloTab.vue';
import SloOnlineDistributors from './SloOnlineDistributors.vue';
import SloRepMap from './SloRepMap.vue';

export default {
  name: 'SloRepLocator',
  components: {
    SloLoader,
    SloButton,
    SloTabs,
    SloTab,
    SloOnlineDistributors,
    SloRepMap
  },
  filters: {
    t
  }
};
</script>

<style lang="scss" scoped>
@import '../../scss/variables';
@import '../../scss/system';

.slo-rep-locator {
  :deep(.slo-tabs) {
    nav {
      position: sticky;
      top: var(--slo-modal-header-height);
      z-index: 100;
      background-color: $color-white;
    }

    nav > ul {
      margin-bottom: 0;
      padding-block: 8px;
      border-bottom: 1px solid $color-gray-400;
      overflow-x: scroll;

      .slo-tabs--bar {
        bottom: 0;
      }

      span {
        font-weight: 500;
        text-transform: uppercase;
      }
    }

    main {
      overflow: initial;

      > div {
        .distributor {
          padding-block: 24px;
          border-bottom: 1px solid $color-gray-400;
        }
      }
    }
  }
}
</style>
